import { useMemo } from "react";
import { CHANGELOG, latestChangelogVersion, unreadChangelogEntries, type ChangelogEntry } from "@workspace/changelog";
import { useChangelogState } from "@/lib/api-extra";

/**
 * Estado de lectura de Novedades. El contenido viene con el build
 * (@workspace/changelog); la API sólo dice hasta qué versión leyó el usuario.
 * Mientras eso no cargó, `hasUnread` es false para que el punto del menú no
 * parpadee.
 */
export function useChangelog() {
  const { data, isSuccess } = useChangelogState();
  const lastSeen = data?.data.ultimaVersionVista ?? null;

  const unread = useMemo<ChangelogEntry[]>(
    () => (isSuccess ? unreadChangelogEntries(lastSeen) : []),
    [isSuccess, lastSeen],
  );

  return {
    entries: CHANGELOG,
    latestVersion: latestChangelogVersion(),
    lastSeen,
    unread,
    hasUnread: unread.length > 0,
    isLoaded: isSuccess,
  };
}
